const GetStartedButton = {
  label: "get started"
};

export default GetStartedButton;
